export const EVENT_TYPES = {
  ACTIVE_USERS: "Active users",
  LOGIN: "Login",
  SING_UP: "SingUp",
  WORKOUT_CREATED: "Workout created by user",
  WORKOUT_SHARED_BY_USER: "Worout shared by user",
  WORKOUT_STARTED: "Workout started",
  WORKOUT_PAUSED: "Workout paused",
  WORKOUT_RESUMED: "Workout resumend",
  WORKOUT_COMPLETED: "Workout completed",
  POST_CREATED: "Post created",
  POST_SHARED: "Post shared",
  POST_COMMENT: "Post comment",
  POST_PUMP: "Post pump",
  SUBSCRIPTION_CREATED: "Subscription creadted",
  PROGRAM_JOIN: "Program join",
  PROGRAM_COMPLETED: "Program completed",
  IAChat_MESSAGE_SENT: "IAChat message sent",
  APP_OPENED: "App opened",
  FINISHED_SUBSCRIPTIONS: "Finished subscriptions",
  AVG_WORKOUT_TIME: "Avg workout time",
}; 